export const PRICING_API_ERROR_KEYS: {[key: string]: string} = {
  '': 'UI.Unable.To.Retrieve.Data.From.BFF.PDP.Pricing.API.For.Unknown.Reasons',
  'OC-BFF-PRC002-ENR001': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Account.Not.Migrated.For.Requested.Account.OFFERS',
  'OC-BFF-PRC002-ENR002': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Channel.Is.Not.Supported.OFFERS',
  'OC-BFF-PRC002-ENR004': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.No.Offers.Found.OFFERS',
  'OC-BFF-PRC002-ENR005': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Vehicle.Not.Found.For.This.Account.OFFERS',
  'OC-BFF-PRC002-ENR006': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Policy.Not.Found.OFFERS',
  'OC-BFF-PRC003-OCBF010': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.Unregognized.Field.OFFERS',
  'OC-BFF-PRC003-OCBF006': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.500.Internal.Server.Error.OFFERS',
  'OC-BFF-PRC001-OCBF004': 'BFF.PDP.Pricing.API.Failure.From.Service.Sales.Offer.Retail.No.Offers.Found.Received.Empty.Response.From.Sales.Offer.Retail.OCBF',
  'OC-BFF-PRC004-ORD0027': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.With.SIL.Payment.SIL',
  'OC-BFF-PRC005-ORD0028': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.With.SIL.Account.Subscription.SIL',
  'OC-BFF-PRC008-ORD008': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Policy.Not.Found.ORDERS',
  'OC-BFF-PRC006-ORD013': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.GAA.Service.Unavailable.GAA',
  'OC-BFF-PRC007-ORD014': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.Occurred.In.GAA.Order.Creation.GAA',
  'OC-BFF-PRC008-ORD019': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.Occurred.In.CVC.Order.Creation.OFFERS',
  'OC-BFF-PRC009-ORD009': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.Occurred.In.Order.Creation.ORDERS',
  'OC-BFF-PRC003-ORD010': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Unrecognized.Field.ORDERS',
  'OC-BFF-PRC011-ORD006': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.500.Internal.Service.Error.ORDERS',
  'OC-BFF-PRC003-ORD003': 'BFF.PDP.Pricing.API.Failure.From.Service.GetOrder.Error.In.Order.Processing.ORDERS'
};

export enum ERROR_MESSAGE_KEY {
  isAssociatedKey = 'copy.user.no.associated.vehicle',
  inActiveVinKey = 'copy.user.no.onstar.enabled',
  familyMemberKey = 'copy.user.not.owner',
  planPurchasedKey = 'copy.similar.product.already',
  inEligibleKey = 'copy.ineligible.user'
}

export const URL_KEYS: {[key: string]: string} = {
  'super-cruise': 'Super Cruise',
  'safety-security': 'Safety and Security',
  'remote-access': 'Remote Access',
  'premium': 'Premium',
  'data': 'Data',
  'app-access': 'App Access',
  'guardian': 'Guardian',
  'essentials': 'Essentials',
  'connected-vehicle': 'Connected Vehicle',
  'preferred': 'OnStar Preferred',
  'preferred-plus-wifi': 'OnStar Preferred Plus WiFi',
  'protection': 'Protection',
  'super-cruise-trailering': 'Super Cruise Trailering',
  'super-cruise-automatic-lane-change': 'Super Cruise Automatic Lane Change',
  'super-cruise-auto-lane-change-trailering': 'Super Cruise Auto Lane Change and Trailering',
  'cadillac-themes-collection': 'Cadillac Themes Collection',
  'signature': 'Signature',
  'tagged': 'Tagged',
  'lost-in-nature': 'Lost in Nature',
  'illumination': 'Illumination',
  'explore-the-unknown': 'Explore the Unknown',
  'velocity': 'Velocity',
  'flex-cam': 'Flex Cam',
  'infinity-tune': 'Infinity Tune',
  'onstar-one': 'OnStar One',
  'onstar-one-super-cruise': 'OnStar One Super Cruise',
  'connect-plus': 'OnStar Connect Plus',
  'connect': 'OnStar Connect'
};

export const ARCHETYPE_KEYS: {[key: string]: string} = {
  'super-cruise': 'wolverine',
  'safety-security': 'wolverine',
  'remote-access': 'wolverine',
  'premium': 'wolverine',
  'data': 'wolverine',
  'app-access': 'wolverine',
  'guardian': 'wolverine',
  'essentials': 'wolverine',
  'connected-vehicle': 'wolverine',
  'preferred': 'wolverine',
  'preferred-plus-wifi': 'wolverine',
  'protection': 'wolverine',
  'super-cruise-trailering': 'scarletknight',
  'super-cruise-automatic-lane-change': 'scarletknight',
  'super-cruise-auto-lane-change-trailering': 'scarletknight',
  'cadillac-themes-collection': 'scarletknight',
  'signature': 'scarletknight',
  'tagged': 'scarletknight',
  'lost-in-nature': 'scarletknight',
  'illumination': 'scarletknight',
  'explore-the-unknown': 'scarletknight',
  'velocity': 'scarletknight',
  'flex-cam': 'scarletknight',
  'infinity-tune': 'scarletknight'
};

export enum VEHICLE {
  UN_AUTHENTICATED_KEY = 'unAuthenticatedVehicleKey',
  START_KEY = 'startVehicle',
  ENTITLEMENTS_KEY = 'vehicleEntitlements',
  PREFERENCES_KEY = 'vehiclePreferences',
  REMOVAL_REASONS = 'vehicleRemovalReasons',
  RESPONSE_KEY = 'vehicles',
  SERVICE_CATEGORIES_KEY = 'vehicleServiceCategories',
  SERVICE_RECORDS_KEY = 'vehicleServiceRecords',
  YEARS_KEY = 'Years'
}

export enum ACTIVE_VEHICLE {
  KEY = 'activeVehicle',
  MILEAGE_UPDATED_KEY = 'activeVehMileageUpdatedKey',
  NOTIFICATIONS_KEY = 'notifications'
}

export const PDP_KEYS = {
  VEHICLE: {
    ...VEHICLE,
    ACTIVE: ACTIVE_VEHICLE
  },
  URL: URL_KEYS,
  ARCHETYPE: ARCHETYPE_KEYS,
  ERROR: {
    PRICING_API: PRICING_API_ERROR_KEYS,
    ...ERROR_MESSAGE_KEY
  }
};
